import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icons/quit.svg'


const _hoisted_1 = {
  key: 0,
  class: "quota-card-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = {
  key: 0,
  class: "bar-info"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "quota-name" }, "Request Left", -1)
const _hoisted_5 = { class: "quota-req-val" }
const _hoisted_6 = {
  key: 1,
  class: "bar-info"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "quota-name" }, "Request Left", -1)
const _hoisted_8 = {
  class: "quota-req-val",
  style: {"color":"red !important"}
}
const _hoisted_9 = {
  key: 2,
  class: "bar"
}
const _hoisted_10 = {
  key: 3,
  class: "bar"
}
const _hoisted_11 = {
  key: 1,
  class: ""
}
const _hoisted_12 = { class: "card-wrapper" }
const _hoisted_13 = {
  key: 0,
  class: "card-quota-info"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "card-quota-name" }, " Request Left ", -1)
const _hoisted_15 = { class: "card-quota-value" }
const _hoisted_16 = {
  key: 1,
  class: "bar"
}
const _hoisted_17 = {
  key: 2,
  class: "bar"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "card-quota-info" }, " Update your request points in Settings ", -1)
const _hoisted_19 = {
  key: 1,
  class: "alert alert-light"
}
const _hoisted_20 = { class: "quota-card-wrapper" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "bar-info" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "quota-name" }, "Request Left", -1)
const _hoisted_24 = { class: "quota-req-val" }
const _hoisted_25 = { class: "bar" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  style: {"cursor":"pointer","width":"20px","height":"20px"},
  src: _imports_0
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_us_modal = _resolveComponent("contact-us-modal")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isSearchHandled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.$route.matched.some(({ name }) => name !== 'home'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                ((_ctx.read_max_search_count - _ctx.read_search_request) > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.read_max_search_count - _ctx.read_search_request) + " / " + _toDisplayString(_ctx.read_max_search_count), 1),
                      _createElementVNode("button", {
                        class: "btn-more",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.moreRequests && _ctx.moreRequests(...args)))
                      }, "more requests")
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.read_max_search_count - _ctx.read_search_request) + " / " + _toDisplayString(_ctx.read_max_search_count), 1),
                      _createElementVNode("button", {
                        class: "btn-more",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moreRequests && _ctx.moreRequests(...args)))
                      }, "more requests")
                    ])),
                ((_ctx.read_max_search_count - _ctx.read_search_request) > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", {
                        style: _normalizeStyle(_ctx.reqLeftBarActive)
                      }, null, 4)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", {
                        style: _normalizeStyle(_ctx.timeLeftBarActive)
                      }, null, 4)
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.userInfo.advertiser.is_premium != true && _ctx.is_tawa_agency_email() == false)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " You have 10 Request par day "))
                    : _createCommentVNode("", true),
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.read_max_search_count - _ctx.read_search_request) + " / " + _toDisplayString(_ctx.read_max_search_count), 1),
                  ((_ctx.read_max_search_count - _ctx.read_search_request) > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", {
                          style: _normalizeStyle(_ctx.reqLeftBarActive)
                        }, null, 4)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", {
                          style: _normalizeStyle([_ctx.reqLeftBarActive, {"background-color":"red !important"}])
                        }, null, 4)
                      ])),
                  _hoisted_18,
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moreRequests && _ctx.moreRequests(...args))),
                    class: "card-btn-more"
                  }, "More Requests")
                ])
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.read_max_search_count - _ctx.read_search_request) + " / " + _toDisplayString(_ctx.read_max_search_count), 1),
                _createElementVNode("button", {
                  class: "btn-more",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moreRequests && _ctx.moreRequests(...args)))
                }, "more requests")
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.reqLeftBarActive)
                }, null, 4)
              ])
            ])
          ])
        ])),
    (_ctx.openContactModal)
      ? (_openBlock(), _createBlock(_component_vue_final_modal, {
          key: 2,
          modelValue: _ctx.openContactModal,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.openContactModal) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "modal__close",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openContactModal = false)),
              role: "button"
            }, _hoisted_27),
            _createVNode(_component_contact_us_modal, {
              subject: _ctx.theContactSubject,
              category: _ctx.theContactCategory,
              onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openContactModal = false))
            }, null, 8, ["subject", "category"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}